import { useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, ArrowLeft, EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";
import apiClient from "../lib/api";
import GcrLogo from "../components/GcrLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) return setError("Ingresa tu email");
    setLoading(true);
    try {
      await apiClient.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Error al procesar la solicitud");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-obsidian-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex items-center gap-2.5 mb-10">
          <div className="w-8 h-8 rounded-lg bg-yellow-400 flex items-center justify-center">
            <Trophy weight="fill" className="w-4 h-4 text-black" />
          </div>
          <GcrLogo size={34} />
        </div>

        {!sent ? (
          <>
            <div className="mb-7">
              <h1 className="text-display font-black text-3xl tracking-tight mb-2">
                Recuperar contraseña
              </h1>
              <p className="text-sm text-zinc-500">
                Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="text-xs text-zinc-500 uppercase tracking-widest font-bold block mb-1.5">
                  Email
                </label>
                <div className="relative">
                  <EnvelopeSimple className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-zinc-500" />
                  <input
                    data-testid="forgot-email-input"
                    type="email"
                    className="input-field w-full pl-10"
                    placeholder="tu@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>

              {error && (
                <p data-testid="forgot-error" className="text-red-400 text-sm font-medium">{error}</p>
              )}

              <button
                data-testid="forgot-submit-btn"
                type="submit"
                disabled={loading}
                className="btn-primary w-full"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Enviando...
                  </span>
                ) : "Enviar enlace de recuperación"}
              </button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-success" className="text-center">
            <div className="w-16 h-16 rounded-full bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mx-auto mb-5">
              <CheckCircle weight="fill" className="w-8 h-8 text-emerald-400" />
            </div>
            <h2 className="text-display font-black text-2xl tracking-tight mb-3">
              ¡Revisa tu bandeja!
            </h2>
            <p className="text-sm text-zinc-400 leading-relaxed mb-6">
              Si el email <span className="text-white font-semibold">{email}</span> está registrado,
              recibirás un enlace para restablecer tu contraseña. Expira en 1 hora.
            </p>
            <p className="text-xs text-zinc-600">
              ¿No ves el email? Revisa tu carpeta de spam.
            </p>
          </div>
        )}

        <div className="mt-8 text-center">
          <Link to="/login" data-testid="forgot-back-login"
            className="flex items-center justify-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Volver al login
          </Link>
        </div>
      </div>
    </div>
  );
}
